export const PropellerTypes = {
  FIXED: 'fixed',
  CONTROLLABLE: 'controllable',
  AZIMUTH: 'Azimuth',
} as const;

export type PropellerType = (typeof PropellerTypes)[keyof typeof PropellerTypes];
